<template>
  <main class="app-content">
    <div class="app-title">
      <div class="row">
        <div class="col-md">
          <h1><i class="fa fa-dashboard"></i> {{ $t('overview') }}</h1>
        </div>
        <div class="col-md">
          <time-range-picker :model="filterFormModel" :label="$t('time')" @change="load" :defaultShortcut="0"></time-range-picker>
        </div>
      </div>
    </div>

    <div class="row" v-if="$store.state.user.role !== 'agency'">
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon"><font-awesome-icon icon="handshake"/></div>
          <div class="info">
            <h4>Client</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.client }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineClient }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon"><i class="fa fa-user-plus"></i></div>
          <div class="info">
            <h4>{{ $t('user') }}</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.user }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineUser }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <router-link to="/report/call">
          <div class="widget-small danger coloured-icon">
            <div class="icon"><font-awesome-icon icon="headphones-alt"/></div>
            <div class="info">
              <h4>{{ $t('call') }}</h4>
              <p><span>{{ $t('total') }}: </span><b>{{ count.callTotal }}</b></p>
              <p><span>{{ $t('connected') }}: </span><b>{{ count.callSuccess }}</b></p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small danger coloured-icon">
          <div class="icon"><font-awesome-icon icon="dollar-sign"/></div>
          <div class="info">
            <h4>{{ $t('finance') }}</h4>
            <p><span>{{ $t('deposit') }}: </span><b>{{ count.deposit | numFormat }}</b></p>
            <p><span>{{ $t('spent') }}: </span><b>{{ count.spent | numFormat }}</b></p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from "../components/TimeRangePicker";

export default {
  components: { TimeRangePicker },
  data: function () {
    return {
      count: {},
      filterFormModel: {},
    };
  },
  methods: {
    load() {
      if (this.$store.state.user.role !== 'agency') {
        this.$bgService.get('/dashboard/count', { params: this.filterFormModel }).then(response => {
          if (response.data) this.count = response.data;
        });
      }
    },
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        overview: 'Overview',
        user: 'User',
        new: 'New',
        online: 'Online',
        call: 'Call',
        total: 'Total',
        connected: 'Connected',
        deposit: 'Deposit',
        spent: 'Spent',
        finance: 'Finance',
        time: 'Time',
      },
      vi: {
        overview: 'Tổng quan',
        user: 'Người dùng',
        new: 'Mới',
        online: 'Online',
        call: 'Cuộc gọi',
        total: 'Tổng',
        connected: 'Kết nối',
        deposit: 'Khách nạp',
        spent: 'Khách tiêu',
        finance: 'Tài chính',
        time: 'Thời gian',
      }
    }
  },
};
</script>
